@if(_columns.length > 0){
<div class="overflowxauto">
    <mat-table class="assignee-table mat-elevation-z8" [dataSource]="dataSource" matSort
        (matSortChange)="sortData($event)">
        @for(column of _columns; track column.key){
        <ng-container [matColumnDef]="column.key">
            <mat-header-cell *matHeaderCellDef [mat-sort-header]="column.key" [disabled]="!!column.no_sort"
                sortActionDescription="Sort by" class="tab-th" [ngClass]="column.header_class"
                [style.min-width]="column.min_width || '120px'"
                [style.max-width]="column.max_width || null">
                {{ column.label }}
            </mat-header-cell>
            <mat-cell *matCellDef="let element; let i=index"
                [ngClass]="[column.cell_class || '', column.hyper_link_cell ? 'hyper-link-cell' : '']"
                (click)="column.clickable ? onCellClick(element) : null" [title]="element[column.key]"
                [style.min-width]="column.min_width || '120px'"
                [style.max-width]="column.max_width || null">
                <ng-container [ngTemplateOutlet]="getCellTemplate(column.type)"
                    [ngTemplateOutletContext]="{ element: element, column: column, i: i }"></ng-container>

                <!-- <span [ngClass]="{'truncate-cell': column.truncate}">{{ element[column.key] }}</span> -->
            </mat-cell>
        </ng-container>
        }
        <mat-header-row *matHeaderRowDef="displayedColumns"></mat-header-row>
        <mat-row [ngClass]="{
            'mat-row-clickable': _config.rowClickable,
            'mat-row-hoverable': _config.rowHoverable ?? _config.rowClickable,
            'mat-row-pointer': _config.rowCursorPointer ?? _config.rowClickable
        }" mat-row
            *matRowDef="let row; columns: displayedColumns;"
            (click)="_config.rowClickable ? rowClick.emit(row) : null"></mat-row>
    </mat-table>
</div>
@if(!_config.hidePaginator){
<mat-paginator [pageSize]="5" [pageSizeOptions]="[5, 10, 15, 20]" showFirstLastButtons
    aria-label="Select page of periodic elements" (page)="onPageChange($event)">
</mat-paginator>
}
}

<!-- Templates for each cell type -->
<ng-template #serialNumber let-i="i" let-paginator="paginator">
    <span>{{ i + 1 + ((paginator?.pageIndex ?? 0) * (paginator?.pageSize ?? 0)) }}</span>
</ng-template>
<ng-template #prefixWithCustomKey let-column="column" let-element="element">
    <span>{{ column.prefix_text }}{{ element[column.custom_key] }}</span>
</ng-template>
<ng-template #hyperLinkDisplayStatic let-column="column">
    <a href="#" tabindex="0">{{ column.static_text }}</a>
</ng-template>
<ng-template #hyperLink let-element="element" let-column="column">
    <a href="#" tabindex="0">{{ element[column.key] }}</a>
</ng-template>
<ng-template #date let-element="element" let-column="column">
    <span class="date-cell" [ngClass]="{'truncate-cell': column.truncate}">
        <span>{{ element[column.key] | date: 'MM/dd/yyyy' }}</span>
        <span class="date-cell-time">{{ element[column.key] | date: 'hh:mm a' }}</span>
    </span>
</ng-template>
<ng-template #toggle let-element="element" let-column="column">
    <mat-slide-toggle [(ngModel)]="element[column.key]" [checked]="element[column.key]"
        (change)="onToggleChange(element, column)">
        {{ element[column.key] ? 'Active' : 'Inactive' }}
    </mat-slide-toggle>
</ng-template>
<ng-template #edit_action let-element="element" let-column="column">
    <!-- <span>{{ element[column.key] }}</span> -->
    <button class="bttn edit-button">
        <svg width="16" height="16" fill="none" viewBox="0 0 16 16">
            <path
                d="M14.116 4.54133C14.4685 4.18895 14.6665 3.71098 14.6666 3.21257C14.6667 2.71416 14.4687 2.23614 14.1163 1.88367C13.7639 1.53119 13.286 1.33314 12.7876 1.33308C12.2892 1.33302 11.8111 1.53095 11.4587 1.88333L2.56133 10.7827C2.40655 10.937 2.29208 11.127 2.228 11.336L1.34733 14.2373C1.3301 14.295 1.3288 14.3562 1.34357 14.4146C1.35833 14.4729 1.38861 14.5262 1.4312 14.5687C1.47378 14.6112 1.52708 14.6414 1.58544 14.6561C1.6438 14.6707 1.70504 14.6693 1.76267 14.652L4.66467 13.772C4.87345 13.7085 5.06345 13.5947 5.218 13.4407L14.116 4.54133Z"
                stroke="#EB1700" stroke-width="1.33333" stroke-linecap="round" stroke-linejoin="round" />
        </svg>
        Edit
    </button>
</ng-template>
<ng-template #delete_action let-element="element" let-column="column">
    <!-- <span>{{ element[column.key] }}</span> -->
    <button class="bttn delete-button">
        <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M2 4H14" stroke="#6A7282" stroke-width="1.33333" stroke-linecap="round" stroke-linejoin="round"/>
            <path d="M12.6666 4V13.3333C12.6666 14 11.9999 14.6667 11.3333 14.6667H4.66659C3.99992 14.6667 3.33325 14 3.33325 13.3333V4" stroke="#6A7282" stroke-width="1.33333" stroke-linecap="round" stroke-linejoin="round"/>
            <path d="M5.33325 4.00016V2.66683C5.33325 2.00016 5.99992 1.3335 6.66659 1.3335H9.33325C9.99992 1.3335 10.6666 2.00016 10.6666 2.66683V4.00016" stroke="#6A7282" stroke-width="1.33333" stroke-linecap="round" stroke-linejoin="round"/>
            <path d="M6.66675 7.3335V11.3335" stroke="#6A7282" stroke-width="1.33333" stroke-linecap="round" stroke-linejoin="round"/>
            <path d="M9.33325 7.3335V11.3335" stroke="#6A7282" stroke-width="1.33333" stroke-linecap="round" stroke-linejoin="round"/>
        </svg>
    </button>
</ng-template>
<ng-template #default let-element="element" let-column="column">
    <span
        [ngClass]="{ 'truncate-cell': column.key !== 'user_request' && column.key !== 'subject', 'user-request-cell': column.key === 'user_request' || column.key === 'subject' }">{{
        element[column.key] }}</span>
</ng-template>
<ng-template #chip_list let-element="element" let-column="column">
    <button
        type="button"
        class="chip-taxonomy-btn"
        *ngIf="element[column.chip_key || column.key]?.length"
        [matTooltip]="element[column.chip_key || column.key].slice(1).join(', ')"
        [matTooltipDisabled]="element[column.chip_key || column.key].length <= 1"
    >
        <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none"
            stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"
            class="chip-taxonomy-icon" aria-hidden="true">
            <circle cx="12" cy="12" r="10"></circle>
            <path d="M12 16v-4"></path>
            <path d="M12 8h.01"></path>
        </svg>
        <span class="chip-taxonomy-text">{{ element[column.chip_key || column.key][0] }}</span>
        <span class="chip-taxonomy-badge" *ngIf="element[column.chip_key || column.key].length > 1"
            >+{{ element[column.chip_key || column.key].length - 1 }}</span>
    </button>
</ng-template>
<ng-template #menu_actions let-element="element" let-column="column">
    <button class="row-menu-trigger" mat-icon-button [matMenuTriggerFor]="rowMenu" (click)="$event.stopPropagation()">
        <span class="row-menu-dots">&#8942;</span>
    </button>
    <mat-menu #rowMenu="matMenu" xPosition="before" class="row-actions-menu-panel">
        @for(item of column.menu_items; track item.action){
        <button
            mat-menu-item
            *ngIf="isMenuItemVisible(item, element)"
            [ngClass]="item.danger_class"
            (click)="onMenuAction(item.action, element)"
        >
            <svg *ngIf="item.icon === 'edit'" xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24"
                fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"
                class="menu-item-icon" aria-hidden="true">
                <path d="M17 3a2.85 2.83 0 1 1 4 4L7.5 20.5 2 22l1.5-5.5Z"></path>
                <path d="m15 5 4 4"></path>
            </svg>
            <svg *ngIf="item.icon === 'block'" xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24"
                fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"
                class="menu-item-icon" aria-hidden="true">
                <circle cx="12" cy="12" r="10"></circle>
                <path d="m4.9 4.9 14.2 14.2"></path>
            </svg>
            <svg *ngIf="item.icon === 'check'" xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24"
                fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"
                class="menu-item-icon" aria-hidden="true">
                <circle cx="12" cy="12" r="10"></circle>
                <path d="m9 12 2 2 4-4"></path>
            </svg>
            <span>{{ item.label }}</span>
        </button>
        }
    </mat-menu>
</ng-template>
<ng-template #version_link let-element="element" let-column="column">
    <button
        type="button"
        class="version-link-btn"
        (click)="onMenuAction(column.click_action || 'view-history', element)"
    >
        <svg xmlns="http://www.w3.org/2000/svg" width="14" height="14" viewBox="0 0 24 24" fill="none"
            stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"
            class="version-link-icon" aria-hidden="true">
            <path d="M3 12a9 9 0 1 0 9-9 9.75 9.75 0 0 0-6.74 2.74L3 8"></path>
            <path d="M3 3v5h5"></path>
            <path d="M12 7v5l4 2"></path>
        </svg>
        <span class="version-link-text">V{{ element[column.custom_key || column.key] }}</span>
    </button>
</ng-template>
<ng-template #status_badge let-element="element" let-column="column">
    <span
        class="status-badge"
        [ngClass]="(element[column.key] | lowercase) === 'active' ? 'status-badge-active' : 'status-badge-inactive'"
    >{{ element[column.key] }}</span>
</ng-template>
<ng-template #version_with_badge let-element="element" let-column="column">
    <span class="version-cell">
        V{{ element[column.custom_key || column.key] }}
        <span class="latest-badge" *ngIf="element[column.badge_key || 'is_latest']">Latest</span>
    </span>
</ng-template>
<ng-template #link_action let-element="element" let-column="column">
    <a
        href="javascript:void(0)"
        class="grid-link-action"
        (click)="onMenuAction(column.click_action || 'link-action', element)"
    >{{ column.static_text || element[column.key] }}</a>
</ng-template>
<ng-template #chip_count let-element="element" let-column="column">
    <button
        type="button"
        class="chip-count-btn"
        *ngIf="element[column.chip_count_key || column.key]?.length"
        (click)="onMenuAction(column.click_action || 'view-chip-count', element)"
    >
        <svg xmlns="http://www.w3.org/2000/svg" width="14" height="14" viewBox="0 0 24 24" fill="none"
            stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"
            class="chip-count-icon" aria-hidden="true">
            <line x1="8" y1="6" x2="21" y2="6"></line>
            <line x1="8" y1="12" x2="21" y2="12"></line>
            <line x1="8" y1="18" x2="21" y2="18"></line>
            <line x1="3" y1="6" x2="3.01" y2="6"></line>
            <line x1="3" y1="12" x2="3.01" y2="12"></line>
            <line x1="3" y1="18" x2="3.01" y2="18"></line>
        </svg>
        {{ element[column.chip_count_key || column.key].length }} {{ column.static_text || 'items' }}
    </button>
</ng-template>
<ng-template #date_range let-element="element" let-column="column">
    <span class="date-range-cell">
        {{ element[column.custom_key] | date: column?.date_format }}
        @if(element[column.key]){
            <span class="date-range-arrow">&rarr;</span>
            <!-- {{ element[column.key] | date: column?.date_format }} -->
            @if (element[column.key] === 'Current Date') {
            <span class="date-range-current">Current Date</span>
            } @else {
                {{ element[column.key] | date: column?.date_format }}
            }
        }
        
    </span>
</ng-template>
<ng-template #job_status_badge let-element="element" let-column="column">
    <span
        class="job-status-badge"
        [ngClass]="column.status_class_map?.[(element[column.key] | lowercase)] || 'job-status-default'"
    >{{ element[column.key] }}</span>
    <svg
        *ngIf="column.status_info_values?.includes(element[column.key] | lowercase)"
        xmlns="http://www.w3.org/2000/svg" width="15" height="15" viewBox="0 0 24 24" fill="none"
        stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"
        class="job-status-info-icon" aria-hidden="true"
        (click)="onMenuAction(column.click_action || 'view-status-info', element)"
    >
        <circle cx="12" cy="12" r="10"></circle>
        <line x1="12" y1="16" x2="12" y2="12"></line>
        <line x1="12" y1="8" x2="12.01" y2="8"></line>
    </svg>
</ng-template>
<ng-template #status_action let-element="element" let-column="column">
    <ng-container *ngIf="column.action_map?.[(element[column.status_key || column.key] | lowercase)] as actionCfg; else noAction">
        <button
            type="button"
            class="status-action-btn"
            (click)="onMenuAction(actionCfg.action, element)"
        >
            <svg *ngIf="actionCfg.icon === 'refresh'" xmlns="http://www.w3.org/2000/svg" width="14" height="14" viewBox="0 0 24 24"
                fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"
                class="status-action-icon" aria-hidden="true">
                <polyline points="23 4 23 10 17 10"></polyline>
                <polyline points="1 20 1 14 7 14"></polyline>
                <path d="M3.51 9a9 9 0 0 1 14.85-3.36L23 10M1 14l4.64 4.36A9 9 0 0 0 20.49 15"></path>
            </svg>
            <svg *ngIf="actionCfg.icon === 'play'" xmlns="http://www.w3.org/2000/svg" width="14" height="14" viewBox="0 0 24 24"
                fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"
                class="status-action-icon" aria-hidden="true">
                <polygon points="5 3 19 12 5 21 5 3"></polygon>
            </svg>
            {{ actionCfg.label }}
        </button>
    </ng-container>
    <ng-template #noAction>
        <span class="status-action-dash">&mdash;</span>
    </ng-template>
</ng-template>